export default __webpack_public_path__ + "static/media/IMG_8547.1de13e58.JPG";